
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1642"}},[_c('g',{attrs:{"data-name":"Group 1641","transform":"translate(-904.752 -461.823)"}},[_c('rect',{attrs:{"data-name":"Rectangle 2371","width":"16","height":"20","rx":"1","transform":"translate(906.752 461.823)","fill":"#adadad"}}),_c('path',{attrs:{"data-name":"Path 1005","d":"M916.166 469.823l2.293-2.293a1 1 0 00-1.414-1.414l-2.293 2.293-2.293-2.293a1 1 0 00-1.414 1.414l2.293 2.293-2.293 2.293a1 1 0 101.414 1.414l2.293-2.293 2.293 2.293a1 1 0 001.414-1.414z"}}),_c('path',{attrs:{"data-name":"Rectangle 2372","fill":"#fff","d":"M909.752 475.823h10v2h-10z"}})]),_c('path',{attrs:{"data-name":"Rectangle 2373","fill":"none","d":"M0 0h20v20H0z"}})])])
          )
        }
      }
    